import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { Card } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import { FiUploadCloud } from 'react-icons/fi'
import { Link, useHistory } from 'react-router-dom'
import Loader from 'react-js-loader'
import Swal from 'sweetalert2'
import { apiRequest } from '../../store/allApi'
const $ = require('jquery')
$.Datatable = require('datatables.net')

const AdminKyc = ({ user }) => {
  const history = useHistory();
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);
  const [userid, setUserId] = useState('');
  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Number, setNumber] = useState('');
  const [DOB, setDob] = useState('');
  const [submitProcess, setProcess] = useState(false);
  
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  const baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  const aadharProcess = useRef(false);

  const handleSubmitData =async (e) => {
    e.preventDefault();
    
      if (aadharProcess.current === false) {
        setProcess(true);
        aadharProcess.current = true;

        const formData = new FormData();
        formData.append('Name', Name);
        formData.append('Email', Email);
        formData.append('userid', userid);
        formData.append('Number', Number);
        formData.append('DOB', DOB);
        formData.append('front', frontLoaded);
        formData.append('back', backLoaded);

        if (frontLoaded && backLoaded) {
          const access_token = localStorage.getItem('token');
          const headers = {
            Authorization: `Bearer ${access_token}`
          };

          
             try {
                            const res = await apiRequest(`admin/aadharcard-admin-kyc`,"POST", formData,headers)
                           if (res) {
                                 if (res.data.status === false) {
                Swal.fire({
                  title: res.data.msg,
                  icon: 'error',
                  confirmButtonText: 'error'
                });
              } else if (res.data.msg === false) {
                Swal.fire({
                  title: 'Duplicate Entity',
                  icon: 'error',
                  confirmButtonText: 'error'
                });
              } else {
                Swal.fire({
                  title: 'Your KYC form submitted',
                  icon: 'success',
                  confirmButtonText: 'ok'
                });
                history.push('/user/kyc');
              }
              aadharProcess.current = false;
              setProcess(false);
                           }
                              } catch (e) {
                                     if (e.response.status === 401) {
                localStorage.removeItem('token');
                window.location.reload();
                history.push('/login');
              }
              aadharProcess.current = false;
              setProcess(false);
                              }
                              finally {
                              }
        } else {
          aadharProcess.current = false;
          setProcess(false);
          alert('Please fill all fields');
        }
      } else {
        alert('You have submitted a request already.');
      }
    
  };

  useEffect(() => {
    let access_token = localStorage.getItem('token');
    if (!access_token) {
      window.location.reload();
      history.push('/login');
    }
  }, []);

  const handleFrontPhotoChange = e => {
    const [file] = e.target.files;
    setFrontLoaded(file);
  };

  const handleBackPhotoChange = e => {
    const [file] = e.target.files;
    setBackLoaded(file);
  };

  const theme = localStorage.getItem('theme');
  const isDark = theme === 'dark';
  const styles = {
    page: {
      minHeight: '100vh',
      padding: '24px',
      background: isDark
        ? 'linear-gradient(135deg, #0f172a 0%, #111827 100%)'
        : 'linear-gradient(135deg, #eff6ff 0%, #f8fafc 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    card: {
      width: '100%',
      maxWidth: '900px',
      border: 'none',
      borderRadius: '24px',
      boxShadow: isDark ? '0 20px 50px rgba(2, 8, 23, 0.35)' : '0 20px 50px rgba(15, 23, 42, 0.12)',
      background: isDark ? '#111827' : '#ffffff',
      color: isDark ? '#f9fafb' : '#111827',
      overflow: 'hidden',
      position: 'relative',
    },
    header: {
      padding: '28px 28px 12px',
      background: isDark ? 'linear-gradient(90deg, #1f2937 0%, #111827 100%)' : 'linear-gradient(90deg, #eff6ff 0%, #ffffff 100%)',
      borderBottom: isDark ? '1px solid #374151' : '1px solid #e5e7eb',
    },
    title: {
      fontSize: '1.6rem',
      fontWeight: 700,
      marginBottom: '6px',
    },
    subtitle: {
      fontSize: '0.95rem',
      color: isDark ? '#cbd5e1' : '#64748b',
      margin: 0,
    },
    body: {
      padding: '28px',
    },
    form: {
      display: 'grid',
      gap: '16px',
    },
    label: {
      display: 'block',
      fontSize: '0.9rem',
      fontWeight: 600,
      marginBottom: '6px',
      color: isDark ? '#e5e7eb' : '#374151',
    },
    input: {
      width: '100%',
      borderRadius: '12px',
      border: isDark ? '1px solid #374151' : '1px solid #d1d5db',
      padding: '12px 14px',
      background: isDark ? '#1f2937' : '#ffffff',
      color: isDark ? '#f9fafb' : '#111827',
      outline: 'none',
    },
    uploadBox: {
      border: `2px dashed ${isDark ? '#4b5563' : '#cbd5e1'}`,
      borderRadius: '16px',
      padding: '20px',
      textAlign: 'center',
      cursor: 'pointer',
      background: isDark ? '#1f2937' : '#f8fafc',
      transition: 'all 0.2s ease',
    },
    uploadIcon: {
      fontSize: '1.8rem',
      color: '#2563eb',
      marginBottom: '8px',
    },
    uploadText: {
      fontSize: '0.95rem',
      color: isDark ? '#e5e7eb' : '#475569',
      fontWeight: 600,
    },
    uploadedState: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      background: isDark ? '#111827' : '#ffffff',
      borderRadius: '12px',
      padding: '10px 12px',
    },
    fileName: {
      fontWeight: 600,
      color: isDark ? '#f9fafb' : '#111827',
      fontSize: '0.95rem',
    },
    fileSize: {
      fontSize: '0.8rem',
      color: isDark ? '#9ca3af' : '#6b7280',
    },
    removeIcon: {
      width: '18px',
      height: '18px',
      cursor: 'pointer',
      flexShrink: 0,
    },
    submitButton: {
      border: 'none',
      borderRadius: '12px',
      padding: '12px 18px',
      background: 'linear-gradient(90deg, #2563eb 0%, #4f46e5 100%)',
      color: '#ffffff',
      fontWeight: 700,
      boxShadow: '0 10px 25px rgba(37, 99, 235, 0.2)',
      marginTop: '8px',
    },
    loaderOverlay: {
      position: 'absolute',
      inset: 0,
      background: 'rgba(15, 23, 42, 0.45)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '24px',
    },
  };

  return (
    <div style={styles.page}>
      <Card style={styles.card}>
        <div style={styles.header}>
          <div style={styles.title}>Aadhaar KYC Submission</div>
          <p style={styles.subtitle}>Enter the user details and upload both sides of the Aadhaar card.</p>
        </div>
        <Card.Body style={styles.body}>
          <form style={styles.form} onSubmit={handleSubmitData}>
            <div className="row g-3">
              <div className="col-12 col-md-6">
                <label style={styles.label}>User ID</label>
                <input
                  type="text"
                  name="userid"
                  placeholder="Enter user id"
                  value={userid}
                  onChange={e => setUserId(e.target.value)}
                  required
                  style={styles.input}
                />
              </div>
              <div className="col-12 col-md-6">
                <label style={styles.label}>Full Name</label>
                <input
                  type="text"
                  name="Name"
                  placeholder="Enter name"
                  value={Name}
                  onChange={e => setName(e.target.value)}
                  required
                  style={styles.input}
                />
              </div>
              <div className="col-12 col-md-6">
                <label style={styles.label}>Email</label>
                <input
                  type="text"
                  name="Email"
                  placeholder="Email Id"
                  value={Email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  style={styles.input}
                />
              </div>
              <div className="col-12 col-md-6">
                <label style={styles.label}>Date of Birth</label>
                <input
                  type="date"
                  name="DOB"
                  value={DOB}
                  onChange={e => setDob(e.target.value)}
                  required
                  style={styles.input}
                />
              </div>
              <div className="col-12">
                <label style={styles.label}>Aadhaar Number</label>
                <input
                  type="tel"
                  name="Number"
                  placeholder="Enter aadhaar number"
                  value={Number}
                  onChange={e => setNumber(e.target.value)}
                  required
                  style={styles.input}
                />
              </div>
            </div>

            <div className="row g-3 mt-1">
              <div className="col-12 col-md-6">
                <label style={styles.label}>Front Side</label>
                <div style={styles.uploadBox} onClick={() => document.getElementById('frontPhoto').click()}>
                  <input
                    id="frontPhoto"
                    name="frontPhoto"
                    type="file"
                    accept="image/*"
                    onChange={handleFrontPhotoChange}
                    required
                    style={{ display: 'none' }}
                  />
                  {!frontLoaded ? (
                    <>
                      <FiUploadCloud style={styles.uploadIcon} />
                      <div style={styles.uploadText}>Upload front photo of your Aadhaar card</div>
                    </>
                  ) : (
                    <div style={styles.uploadedState}>
                      <div>
                        <div style={styles.fileName}>{frontLoaded.name}</div>
                        <div style={styles.fileSize}>{(frontLoaded.size / 1024 / 1024).toFixed(2)} MB</div>
                      </div>
                      <img
                        src="/images/global-cross.png"
                        alt="remove"
                        style={styles.removeIcon}
                        onClick={e => {
                          e.stopPropagation();
                          setFrontLoaded(null);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6">
                <label style={styles.label}>Back Side</label>
                <div style={styles.uploadBox} onClick={() => document.getElementById('backPhoto').click()}>
                  <input
                    id="backPhoto"
                    name="backPhoto"
                    type="file"
                    accept="image/*"
                    onChange={handleBackPhotoChange}
                    required
                    style={{ display: 'none' }}
                  />
                  {!backLoaded ? (
                    <>
                      <FiUploadCloud style={styles.uploadIcon} />
                      <div style={styles.uploadText}>Upload back photo of your Aadhaar card</div>
                    </>
                  ) : (
                    <div style={styles.uploadedState}>
                      <div>
                        <div style={styles.fileName}>{backLoaded.name}</div>
                        <div style={styles.fileSize}>{(backLoaded.size / 1024 / 1024).toFixed(2)} MB</div>
                      </div>
                      <img
                        src="/images/global-cross.png"
                        alt="remove"
                        style={styles.removeIcon}
                        onClick={e => {
                          e.stopPropagation();
                          setBackLoaded(null);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <button type="submit" style={styles.submitButton}>Submit KYC</button>
          </form>
        </Card.Body>
        {submitProcess && (
          <div style={styles.loaderOverlay}>
            <img src="/images/LandingPage_img/loader1.gif" alt="loading" style={{ width: '70px', height: '70px' }} />
          </div>
        )}
      </Card>
    </div>
  );
};

export default AdminKyc;
